// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.confirm-dialog-rule-save-title {
  font-size: 18px !important;
  font-weight: 700 !important;
  line-height: 1.35;
}

.confirm-dialog-rule-save-message {
  line-height: 1.5;
}

.confirm-dialog-rule-save-message strong {
  font-weight: 700;
}

::ng-deep .rule-config-overwrite-confirm-panel .mat-mdc-dialog-title,
::ng-deep .rule-config-overwrite-confirm-panel .mat-dialog-title {
  font-size: 18px !important;
  font-weight: 700 !important;
}

.Btn_confirm:focus {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}

.Btn_confirm:hover {
  background-color: #ffffff !important;
  color: black !important;
  border: 1px solid;
}

.Template_dropDown {
  height: 32px;
  border-radius: 5px;
  padding-inline: 1%;
  position: relative;
  top: 1%;
  background-color: white;
  margin-left: 1px;
  margin-right: 1%;
  margin-block: 1%;
}

::ng-deep.Template_dropDownDialog .mat-form-field-infix {
  border: 0 !important;
  height: 33px !important;
  font-size: 13px;
}

::ng-deep.Template_dropDownDialog .mat-form-field-appearance-outline .mat-form-field-wrapper {
  padding: 1%;
  margin: 1%;
}

::ng-deep.Template_dropDownDialog .mat-form-field-label-wrapper {
  top: -1px !important;
}

::ng-deep.Template_dropDownDialog .mat-select-trigger {
  min-width: 10vw;
}

::ng-deep.cdk-overlay-backdrop {
  height: 84vh !important;
  top: 16% !important;
  width: 100vw !important;
  left: 0% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/confirm-dialog/confirm-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,2BAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAGE;;EAEE,0BAAA;EACA,2BAAA;AAAJ;;AAIA;EACI,oCAAA;EACE,uBAAA;EACA,iBAAA;AADN;;AAGE;EACE,oCAAA;EACE,uBAAA;EACA,iBAAA;AAAN;;AAEE;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;;AACE;EACE,oBAAA;EACA,uBAAA;EACA,eAAA;AAEJ;;AAAE;EACE,WAAA;EACA,UAAA;AAGJ;;AADE;EACE,oBAAA;AAIJ;;AAFE;EACE,eAAA;AAKJ;;AAHE;EACE,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAMJ","sourcesContent":[".confirm-dialog-rule-save-title {\r\n  font-size: 18px !important;\r\n  font-weight: 700 !important;\r\n  line-height: 1.35;\r\n}\r\n\r\n.confirm-dialog-rule-save-message {\r\n  line-height: 1.5;\r\n}\r\n\r\n.confirm-dialog-rule-save-message strong {\r\n  font-weight: 700;\r\n}\r\n\r\n::ng-deep .rule-config-overwrite-confirm-panel {\r\n  .mat-mdc-dialog-title,\r\n  .mat-dialog-title {\r\n    font-size: 18px !important;\r\n    font-weight: 700 !important;\r\n  }\r\n}\r\n\r\n.Btn_confirm:focus{\r\n    background-color: #ffffff !important;\r\n      color: black !important;\r\n      border: 1px solid;\r\n  }\r\n  .Btn_confirm:hover{\r\n    background-color: #ffffff !important;\r\n      color: black !important;\r\n      border: 1px solid;\r\n  }\r\n  .Template_dropDown{\r\n    height: 32px;\r\n    border-radius: 5px;\r\n    padding-inline: 1%;\r\n    position: relative;\r\n    top: 1%;\r\n    background-color: white;\r\n    margin-left: 1px;\r\n    margin-right: 1%;\r\n    margin-block: 1%;\r\n  }\r\n  ::ng-deep.Template_dropDownDialog  .mat-form-field-infix{\r\n    border: 0 !important;\r\n    height: 33px !important;\r\n    font-size: 13px;\r\n  }\r\n  ::ng-deep.Template_dropDownDialog .mat-form-field-appearance-outline .mat-form-field-wrapper{\r\n    padding: 1%;\r\n    margin: 1%;\r\n  }\r\n  ::ng-deep.Template_dropDownDialog .mat-form-field-label-wrapper{\r\n    top:-1px !important;\r\n  }\r\n  ::ng-deep.Template_dropDownDialog  .mat-select-trigger {\r\n    min-width: 10vw;\r\n  }\r\n  ::ng-deep.cdk-overlay-backdrop{\r\n    height: 84vh !important;\r\n    top: 16% !important;\r\n    width: 100vw !important;\r\n    left: 0%!important;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
